var myLazyLoad = new LazyLoad({
    elements_selector: ".lazy"
});

$(function() {
    var mobile = false;
    var tablet = false;
    var desktop = false;
    var mobNav = false;
    var deskNav = false;

    // Reusable functions
    function showOnHover(source, target) {
        $(source).on('mouseenter',
            function() {
                $(target).addClass('show');
            }).on('mouseleave',
            function() {
                $(target).removeClass('show');
            }
        );
    }
    // end reusable functions

    /* Detections */
    var root = document.getElementsByTagName('html')[0];
    if (!document.createElement('svg').getAttributeNS) {
        root.setAttribute("class", "no-svg");
        return;
    }
    /* IE 10 Detection due to checkbox issues */
    if (Function('/*@cc_on return document.documentMode===10@*/')()) {
        document.documentElement.className += ' ie10';
    }
    /* End Detections */

    /* polyfill fix for chair animation */
    if (!window.location.origin) {
        window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
    }

    function checkWidth() {
        var viewportWidth = window.viewportSize.getWidth();
        if (viewportWidth <= 768) {
            if (!mobile) {
                $('body').addClass('mobile').removeClass('desktop');
                $('body.pgproduct .cart-handler h1').insertAfter('ul.breadcrumb');
                $('body.pgproduct ul.slides li a').contents().unwrap();
            }
            mobile = true;
            desktop = false;
            tablet = false;
        } else if (viewportWidth >= 769 && viewportWidth <= 960) {
            if (!tablet) {
                $('body').removeClass('mobile dekstop').addClass('tablet');
            }
            mobile = false;
            desktop = false;
            tablet = true;
        } else {
            if (!desktop) {
                $('body').removeClass('mobile').addClass('desktop');
            }
            mobile = false;
            desktop = true;
            tablet = false;
        }
        if ( viewportWidth <= 1200) { 
            if(!mobNav) {
                $('.header nav').insertAfter('.header .header-inner');
            }
            mobNav = true
            deskNav = false
        } else {
            if(!deskNav) {
                $('.header nav').insertBefore('.header .utilities');

            }
            mobNav = false
            deskNav = true


        }
    }
    checkWidth();
    $(window).on('resize', checkWidth);
    
    /* Menus*/
    function toggleTopNav() {
        $("#btn-main-nav").toggleClass('activated inactive');
        $('ul.top-nav').fadeToggle(0);
    }
    function toggleSearch() {
        $("div.search").toggleClass('search-open search-closed');
        $('.search-open input[type=search]').trigger('focus');     
    }
    $("#btn-search").on('click', function() {
        if ($("ul.top-nav").not('body.desktop ul.top-nav').is(":visible")) {
            toggleTopNav();
        }
        $(this).toggleClass('search-inactive search-active');
        // Check if the #btn-search element has the 'active' class
        if ($("#btn-search").hasClass("search-active")) {
            $("#btn-search").attr("aria-label", "Close search bar");
            $("#btn-search").attr("aria-expanded", "true");
        } else {
            $("#btn-search").attr("aria-label", "Open search bar");
            $("#btn-search").attr("aria-expanded", "false");
        }
        toggleSearch();
    });
    $("#btn-main-nav").on('click', function() {
        if ($("div.search").hasClass("search-open")) {
            $("#btn-search").toggleClass('search-inactive search-active');
            toggleSearch();
        }        
        toggleTopNav();
    });


    const $tabButtonsWrap = $('#tabs > .tab-links');
    const $tabFirstBtn = $tabButtonsWrap.find('button').eq(0);

    $("#tabs > div").hide();
    $("#tabs > div:first").show();
    $tabFirstBtn.addClass('active');
    
    $tabButtonsWrap.on('click', 'button', function () {
        const $this = $(this);
        const $sibling = $this.siblings();
    
        $sibling.removeClass('active').attr({
            'tabindex': '-1',
            'aria-selected': 'false'
        });
    
        $this.addClass('active').attr({
            'tabindex': '0',
            'aria-selected': 'true'
        });
    
        var currentTab = $this.attr('aria-controls');
        $("#tabs > div").hide();
        $(`#${currentTab}`).show();
        return false;
    });
    /* Slide Up Elements */
    $('.anim').addClass("hidden").viewportChecker({
        classToAdd: 'visible animation fadeInUp',
        offset: 40
    });

    /* Slide Right Elements */
    $('.anim-right').addClass("hidden").viewportChecker({
        classToAdd: 'visible animation fadeInRight',
        offset: 200
    });

    /* Slide Left Elements */
    $('.anim-left, .mobile-cta span').addClass("hidden").viewportChecker({
        classToAdd: 'visible animation fadeInLeft',
        offset: 40
    });

    /* Fade In Elements */
    $('.anim-fade, .mobile-cta span').addClass("hidden").viewportChecker({
        classToAdd: 'visible animation fadeIn',
        offset: 40
    });

    /* Slide Right for Pseudoelements */
    $('.product-container').viewportChecker({
        classToAdd: 'pseudo-animation',
        offset: 200
    });

    /* Lazy Load Background Images*/
    $('.sites-wrapper').viewportChecker({
        classToAdd: 'visible',
        offset: -250
    });

    /* Coco Mango Slide */
    $('.row-bath').addClass('not-animated').viewportChecker({
        classToAdd: 'animated',
        offset: 350,
        callbackFunction: function () {
            runCocoMangoAnim()
        }
    });

    var vieWidth = window.viewportSize.getWidth();

    /* Promo Headers - */
    (function($) {
        $.fn.flowtype = function(options) {
            var settings = $.extend({
                    maximum: 9999,
                    minimum: 1,
                    maxFont: 9999,
                    minFont: 1,
                    fontRatio: 35
                }, options),
                changes = function(el) {
                    var $el = $(el),
                        elw = $el.width(),
                        width = elw > settings.maximum ? settings.maximum : elw < settings.minimum ? settings.minimum : elw,
                        fontBase = width / settings.fontRatio,
                        fontSize = fontBase > settings.maxFont ? settings.maxFont : fontBase < settings.minFont ? settings.minFont : fontBase;
                    $el.css('font-size', fontSize + 'px');
                };

                return this.each(function() {
                    var that = this;
                    $(window).on('resize', function() {
                        changes(that);
                    });
                    changes(this);
                });
        };
    }(jQuery));
    $('#hdr-banner p, .sweeps_banner').flowtype({
        minimum: 420,
        maximum: 1200,
        minFont: 17,
        maxFont   : 45,
        fontRatio: 35
    });
    $('.promo-wrapper .promo-inner').flowtype({
        minimum: 420,
        maximum: 1200,
        minFont: 16,
        maxFont   : 30,
        fontRatio: 35
    });

    /*Hover Intent*/
    var $dropdowns = $('.shop-cart');
    $dropdowns
        .on('mouseover', function() {
            var $this = $(this);
            if ($this.prop('hoverTimeout')) {
                $this.prop('hoverTimeout', clearTimeout($this.prop('hoverTimeout')));
            }
            $this.prop('hoverIntent', setTimeout(function() {
                $this.addClass('hover');
            }, 200));
        })
        .on('mouseleave', function() {
            var $this = $(this);
            if ($this.prop('hoverIntent')) {
                $this.prop('hoverIntent', clearTimeout($this.prop('hoverIntent')));
            }
            $this.prop('hoverTimeout', setTimeout(function() {
                $this.removeClass('hover');
            }, 400));
        });

    /*Hover Intent*/
    var $topNav = $('.top-nav > li');
    $topNav
        .on('mouseover', function() {
            var $this = $(this);
            if ($this.prop('hoverTimeout')) {
                $this.prop('hoverTimeout', clearTimeout($this.prop('hoverTimeout')));
            }
            $this.prop('hoverIntent', setTimeout(function() {
                $this.addClass('open');
            }, 0));
        })
        .on('mouseleave', function() {
            var $this = $(this);
            if ($this.prop('hoverIntent')) {
                $this.prop('hoverIntent', clearTimeout($this.prop('hoverIntent')));
            }
            $this.prop('hoverTimeout', setTimeout(function() {
                $this.removeClass('open');
            }, 0));
        });
    /* Add current class to top navigation li if == current category */
    (function() {
        var navLinks = document.querySelectorAll('#main-nav > li > a');
        var bodyClasses = document.body.classList.toString();
        var currentCategory;
        if (bodyClasses.indexOf('pgcategory') !== -1) {
            currentCategory = document.querySelectorAll('#DIVbreadcrumb li')[1].innerHTML.toLowerCase();
        } else if (bodyClasses.indexOf('pgproduct') !== -1) {
            currentCategory = document.querySelectorAll('#DIVbreadcrumb li')[1].querySelector('a').innerHTML.toLowerCase();
        }
        for (var $i = 0; $i < navLinks.length; $i++) {
            if (currentCategory === navLinks[$i].querySelector('span').innerHTML.toLowerCase()) {
                navLinks[$i].parentElement.classList.add('current');
            }
        }
    })();

    if ($("body").hasClass("pghome") == true) {
        runSlider();
        // runParallax();
    }

        /* ADA AAA
    Main navigation menu */
    $(function () {
        var $dropdowns = $("#main-nav .dropdown");
        var $dropdownsLinks = $("#main-nav .dropdownLink");
        $dropdownsLinks.on("focus",function(){
          let $thisParent = $(this).parent();
          $dropdowns.removeClass("open");
          $dropdownsLinks.attr("aria-expanded", "false");
          $thisParent.addClass("open");
          $(this).attr("aria-expanded", "true");
        })
    
        $('#main-nav').on("focusout", function() {
            setTimeout(() => {
              // if active element is outside the div.header-container...
              if ($(document.activeElement).parents('#main-nav').length === 0) {
                // remove hover functionality
                $dropdowns.removeClass("open");
                $dropdownsLinks.attr("aria-expanded", "false");
              }
            }, 100);
        })
    }); 
    
}); /* end document.ready */

/* Slide In Animations Viewport Check */
(function($) {
    $.fn.viewportChecker = function(useroptions) {
        var options = {
            classToAdd: 'visible',
            offset: 100,
            callbackFunction: function(elem) {}
        };
        $.extend(options, useroptions);
        var $elem = this,
            windowHeight = $(window).height();

        this.checkElements = function() {
            // Set some vars to check with
            var viewportTop = Math.max($('html').scrollTop(), $('body').scrollTop(), $(window).scrollTop()),
                viewportBottom = (viewportTop + windowHeight);

            $elem.each(function() {
                var $obj = $(this);
                if ($obj.hasClass(options.classToAdd)) {
                    return;
                }
                var elemTop = Math.round($obj.offset().top) + options.offset,
                    elemBottom = elemTop + ($obj.height());
                if ((elemTop < viewportBottom) && (elemBottom > viewportTop)) {
                    $obj.addClass(options.classToAdd);
                    options.callbackFunction($obj);
                }
            });
        };
        $(window).on('scroll', this.checkElements);
        this.checkElements();
        $(window).on('resize', function(e) {
            windowHeight = e.currentTarget.innerHeight;
        });
    };
})(jQuery);

function runSlider () {
    var sliderContainer = document.querySelector('.slider-container');
    var sliderWrappers  = sliderContainer.querySelectorAll('.slide');
    var sliderContents  = sliderContainer.querySelectorAll('.slide .txt-wrapper');
    var imgContainers   = sliderContainer.querySelectorAll('.slide .img-container');
    var btnPrev         = sliderContainer.querySelector('#bathSlideBtnLeft');
    var btnNext         = sliderContainer.querySelector('#bathSlideBtnRight');

    var Slider = {
        currentItem: 0,
        init: function init() {
            sliderWrappers.forEach(function (item) {
                item.style.visibility = "hidden";
            });
            gsap.set(sliderWrappers[Slider.currentItem], {autoAlpha: 1})
        },
        out: function out(index, nextIndex) {
            const thisSlide = sliderWrappers[index];
            const nextSlide = sliderWrappers[nextIndex];
            const timeline  = gsap.timeline();

            timeline
                .to(sliderContents[nextIndex], { duration: 0, yPercent: -40 })
                .to(imgContainers[nextIndex], { duration: 0, xPercent: 5 })
                .to(thisSlide, { duration: 0.5, autoAlpha: 0, onComplete: nextSlide.classList.add('transition') })
                .to(nextSlide, { duration: 0.5, autoAlpha: 1, onComplete: () => thisSlide.classList.remove('transition') })
                .to(sliderContents[nextIndex], { duration: 0.5, yPercent: -50 }, "-=.5")
                .to(imgContainers[nextIndex], { duration: 0.5, xPercent: 0 }, "-=.5")
                .set(sliderContents[index], { clearProps: 'all' })
                .set(imgContainers[index], { clearProps: 'all' });
        },

        next: function next() {
            var next = Slider.currentItem !== sliderWrappers.length -1 ? Slider.currentItem + 1 : 0;
            Slider.out(Slider.currentItem, next);
            Slider.currentItem = next;
        },
        prev: function prev() {
            var prev = Slider.currentItem > 0 ? Slider.currentItem - 1 : sliderWrappers.length - 1;
            Slider.out(Slider.currentItem, prev);
            Slider.currentItem = prev;
        }

    };

    btnNext.addEventListener('click', Slider.next);
    btnPrev.addEventListener('click', Slider.prev);
    Slider.init();
}
// function parallax(e, target, movement) {
//     var relX = e.pageX - (frProductsWrap.getBoundingClientRect().left + window.pageXOffset);
//     var relY = e.pageY - (frProductsWrap.getBoundingClientRect().top + window.pageYOffset);

//     gsap.to(target, {
//         duration: 1,
//         x: (relX - frProductsWrap.offsetWidth / 2) / frProductsWrap.offsetWidth * movement,
//         y: (relY - frProductsWrap.offsetHeight / 2) / frProductsWrap.offsetHeight * movement
//     });
// }
// function runParallax(){
//     var frProductsWrap = document.getElementById('frProductsWrap');
//     frProductsWrap.addEventListener('mousemove', function(e) {
//         parallax(e, "#frPar1", 25);
//         parallax(e, "#frPar2", 35);
//         parallax(e, "#frPar3", 45);
//     });
// }
function runCocoMangoAnim() {
    var leftImage   = document.querySelector('.support-image.left');
    var rightImage  = document.querySelector('.support-image.right');
    var timeline    = gsap.timeline();

    // gsap.set(item, {zIndex: 1});
    timeline
        .to(leftImage, { duration: 1.4, xPercent: -50, ease: 'circ.out' })
        .to(rightImage, { duration: 1.4, xPercent: 50, ease: 'circ.out' }, 0)
}